module.exports = __webpack_public_path__ + "img/Picture3.160493ca.jpg";